import { MARKET_COUNTRY_OPTIONS, restoredProductLanguage } from "./experience-catalog.mjs";

const FALLBACK_LOCALE = "en-US";
const FALLBACK_COUNTRY = "US";
const FALLBACK_LANGUAGE = "en";
const COUNTRY_BY_CODE = new Map(MARKET_COUNTRY_OPTIONS.map((country) => [country.code, country]));

function normalizedLocale(value) {
  return String(value || "")
    .trim()
    .replaceAll("_", "-");
}

function localeRegion(value) {
  return normalizedLocale(value)
    .split("-")
    .slice(1)
    .find((segment) => /^[A-Z]{2}$/i.test(segment))
    ?.toUpperCase();
}

function intlLocale() {
  try {
    return normalizedLocale(Intl.DateTimeFormat().resolvedOptions().locale) || FALLBACK_LOCALE;
  } catch {
    return FALLBACK_LOCALE;
  }
}

export function browserLocale() {
  if (typeof navigator !== "undefined") {
    const candidates = [...(navigator.languages || []), navigator.language];
    const preferred = candidates.map(normalizedLocale).find(Boolean);
    if (preferred) return preferred;
  }
  return intlLocale();
}

export function browserMarketExperienceForLocale(value) {
  return browserMarketExperienceForLocales([value]);
}

export function browserMarketExperienceForLocales(values) {
  const candidates = (Array.isArray(values) ? values : [values])
    .map(normalizedLocale)
    .filter(Boolean);
  const marketLocale = candidates.find((candidate) => COUNTRY_BY_CODE.has(localeRegion(candidate)));
  const country = localeRegion(marketLocale) || FALLBACK_COUNTRY;
  const supportedLanguages = COUNTRY_BY_CODE.get(country)?.languages || [];
  const language = candidates
    .map((candidate) => restoredProductLanguage(candidate))
    .find((candidate) => candidate && supportedLanguages.includes(candidate));
  return Object.freeze({
    country,
    lang: language || FALLBACK_LANGUAGE,
  });
}

export function browserMarketExperience() {
  const candidates =
    typeof navigator === "undefined" ? [] : [...(navigator.languages || []), navigator.language];
  return browserMarketExperienceForLocales([...candidates, intlLocale()]);
}
